import "./documents.scss";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { pathAtom, selectorDocuments } from "src/storage";

export const useDocuments = () => {
  const { t } = useTranslation();
  const documents = useRecoilValue(selectorDocuments);
  const setPath = useSetRecoilState(pathAtom);

  useEffect(() => {
    setPath(location.pathname);
  }, [location.pathname, setPath]);

  const openDocument = (link: string) => {
  if (!link) return;

    window.open(link.replaceAll('"', "").toString(), "_blank");
  };

  return {
    t,
    documents,
    openDocument,
  };
};
